import { render, staticRenderFns } from "./EmailMessenger.vue?vue&type=template&id=4d9dc6a4&scoped=true"
import script from "./EmailMessenger.vue.js?vue&type=script&lang=js&external"
export * from "./EmailMessenger.vue.js?vue&type=script&lang=js&external"
import style0 from "./EmailMessenger.vue?vue&type=style&index=0&id=4d9dc6a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9dc6a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
